import { motion } from "framer-motion";
import { BadgeCheck, ShieldCheck, Clock } from "lucide-react";
import { scrollToId } from "@/components/Nav";

export const Chauffeur = () => (
  <section className="py-20 lg:py-32 bg-obsidian text-cream overflow-hidden" data-testid="chauffeur-section">
    <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-20 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
      <motion.div
        initial={{ opacity: 0, y: 32 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.9, ease: [0.215, 0.61, 0.355, 1] }}
        className="lg:col-span-5 relative"
      >
        <div className="absolute -inset-4 border border-gold/30 pointer-events-none" />
        <div className="overflow-hidden">
          <img
            src="/chauffeur.jpeg"
            alt="Votre chauffeur privé DCR"
            className="w-full aspect-[4/5] object-cover object-top hover:scale-105 transition-transform duration-700"
            loading="lazy"
            data-testid="chauffeur-photo"
          />
        </div>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: 32 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.9, delay: 0.15, ease: [0.215, 0.61, 0.355, 1] }}
        className="lg:col-span-7"
      >
        <p className="text-xs uppercase tracking-[0.25em] font-mono text-gold font-semibold mb-6">Votre chauffeur</p>
        <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.08] mb-8">
          Un seul interlocuteur, <span className="italic text-gold">du premier appel à l'arrivée.</span>
        </h2>
        <p className="text-sm sm:text-base leading-relaxed text-neutral-300 max-w-xl mb-10">
          Chauffeur privé agréé VTC, je vous conduis personnellement à bord de ma Toyota C-HR hybride. Pas de sous-traitance, pas d'inconnu : la même personne vous accueille, vous conduit et s'adapte à vos horaires.
        </p>
        <ul className="space-y-4 mb-12">
          <li className="flex items-center gap-3 text-sm text-neutral-300"><BadgeCheck size={16} className="text-gold shrink-0" /> Carte professionnelle VTC — chauffeur certifié</li>
          <li className="flex items-center gap-3 text-sm text-neutral-300"><ShieldCheck size={16} className="text-gold shrink-0" /> Discrétion et confidentialité garanties</li>
          <li className="flex items-center gap-3 text-sm text-neutral-300"><Clock size={16} className="text-gold shrink-0" /> Ponctualité absolue, suivi de vol pour les aéroports</li>
        </ul>
        <button
          data-testid="chauffeur-booking-cta"
          onClick={() => scrollToId("#reservation")}
          className="bg-gold text-obsidian text-xs uppercase tracking-[0.2em] font-semibold px-7 py-4 hover:bg-cream transition-colors duration-300"
        >
          Réserver avec votre chauffeur
        </button>
      </motion.div>
    </div>
  </section>
);
